export const LOGO = "https://d33j98c122wnb5.cloudfront.net/images/coinnekt/logo.svg"
export const LOGO_DARK = "https://d33j98c122wnb5.cloudfront.net/images/coinnekt/logo_dark.svg"
export const LOGO_FULL = "https://d33j98c122wnb5.cloudfront.net/images/coinnekt/logo_full.svg"
export const LOGO_FULL_DARK = "https://d33j98c122wnb5.cloudfront.net/images/coinnekt/logo_full_dark.svg"
